import { render } from "./Main.vue?vue&type=template&id=707fd381&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=707fd381&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-707fd381"

export default script